function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { toggleMark } from 'prosemirror-commands';
import { NodeSelection } from 'prosemirror-state';
import { buildMenuItems } from 'prosemirror-example-setup';
import { Dropdown, MenuItem } from 'prosemirror-menu';
import { imageIcon } from './menu/image';
import { getDocFormat, DocFormatEnum, isInlineDocFormat, prettyPrintLabel } from './utils';
import { insertVariable, insertPillbox, markActive, menuBarBuilder, MenuItemEnum } from './menu/utils';
import { WithActiveAsLabelDropdown } from './menu/dropdown';
import { isPresent } from '@ember/utils';
import { icons } from 'prosemirror-menu';

// Override icons
icons.strong = {
  width: 25,
  height: 32,
  path: 'M2 .245a2.185 2.185 0 0 0-1.348 1.29l-.089.236-.011 13.972C.542 28.398.547 29.739.607 29.972c.175.68.714 1.237 1.409 1.456l.297.093h7.041c5.573 0 7.12-.012 7.417-.055a9.672 9.672 0 0 0 1.706-.39 8.66 8.66 0 0 0 5.831-9.491 8.687 8.687 0 0 0-3.797-5.944l-.343-.226.298-.364c1.042-1.269 1.721-2.818 1.978-4.509.099-.648.098-1.886-.001-2.542-.396-2.628-1.823-4.88-4.026-6.352-.792-.529-2.042-1.061-2.979-1.268-.98-.217-.876-.213-7.262-.211C2.612.171 2.214.176 2 .245m12.104 4.149a4.922 4.922 0 0 1 4.229 4.877c0 1.385-.531 2.617-1.545 3.584-.662.631-1.4 1.021-2.371 1.254-.29.069-.663.076-5.011.088l-4.698.014V4.333l4.49.001c3.667.001 4.566.012 4.906.06m2.469 14.086c.892.169 1.622.552 2.291 1.201a4.48 4.48 0 0 1 1.209 2.057c.101.366.113.478.113 1.095.002.791-.056 1.109-.312 1.738-.519 1.271-1.642 2.247-3.021 2.627l-.415.114-5.865.012-5.865.011v-8.918h5.767c4.971 0 5.812.008 6.098.063'
};
icons.em = {
  width: 21,
  height: 32,
  path: 'M9.882.178C8.907.343 8.156 1.24 8.156 2.24c0 .577.19 1.029.614 1.461.234.238.334.311.578.425.396.183.617.214 1.553.214h.798l-.021.103c-.029.146-6.291 22.833-6.311 22.865-.009.015-.66.027-1.447.027-.914 0-1.499.014-1.617.039A2.11 2.11 0 0 0 .72 28.901c-.07.27-.071.774-.001 1.042.03.114.104.31.166.436.15.309.588.747.9.902.467.231.184.219 5.18.219 4.996 0 4.713.012 5.18-.219.313-.155.753-.594.905-.903a1.9 1.9 0 0 0 .215-.944c0-.628-.172-1.046-.612-1.487-.195-.196-.35-.315-.51-.393-.392-.191-.582-.218-1.547-.218-.476-.001-.866-.013-.866-.027 0-.015 1.424-5.185 3.164-11.489l3.163-11.462 1.518-.02c1.668-.021 1.665-.02 2.113-.255.273-.143.702-.572.845-.845.615-1.174.029-2.591-1.248-3.016-.182-.061-.434-.064-4.707-.069C12.094.15 9.981.161 9.882.178'
};
icons.orderedList = {
  width: 32,
  height: 32,
  path: 'M4.72.65c-.395.108-.74.404-2.244 1.92C.823 4.237.738 4.351.703 4.96.628 6.285 2.09 7.154 3.205 6.448c.134-.085.26-.155.28-.155.019 0 .035 1.032.035 2.294v2.293h-.547c-.997.001-1.384.116-1.805.535-.779.775-.558 2.089.439 2.621l.233.124 2.741.015c3.136.018 3.059.027 3.546-.418.375-.344.529-.691.53-1.199.002-.867-.625-1.545-1.524-1.65l-.306-.036-.001-4.249c0-2.669-.021-4.376-.055-4.589-.096-.591-.416-1.038-.915-1.279C5.57.616 5.026.566 4.72.65m8.26 9.434c-.376.145-.784.56-.93.949-.147.389-.124.95.053 1.295.169.33.508.659.825.802.262.118.333.123 1.939.14 1.612.017 1.669.022 1.725.126.032.06.038.127.013.15-.025.022-.813.551-1.752 1.174-.938.622-1.834 1.255-1.99 1.406-.319.308-.584.747-.761 1.261-.175.509-.177 1.426-.005 1.946.401 1.21 1.307 2.042 2.494 2.294.543.115 3.781.114 4.169-.001.411-.122.772-.436.974-.845.42-.854.049-1.862-.831-2.26-.182-.082-.434-.098-1.89-.121l-1.68-.027 1.762-1.179c1.951-1.306 2.122-1.456 2.467-2.166.282-.579.355-.91.352-1.588-.003-.465-.028-.632-.149-.987-.424-1.242-1.288-2.06-2.508-2.372-.382-.098-.585-.107-2.212-.105-1.652.003-1.813.011-2.065.108m11.139 9.438a1.665 1.665 0 0 0-.772.759c-.098.186-.12.31-.119.706 0 .418.018.515.143.753.079.15.254.37.389.489.429.377.539.397 2.362.433 1.345.026 1.624.045 1.664.11.083.135.116.453.061.596-.051.134-.065.137-.758.175-.855.046-1.166.147-1.518.489-.67.651-.669 1.69.001 2.348.369.362.659.457 1.519.496.644.03.668.035.742.167.095.171.044.494-.103.64-.098.098-.189.104-1.648.104-1.81 0-1.944.027-2.399.482-.814.814-.556 2.197.498 2.675.268.121.304.123 2.112.123 1.623 0 1.881-.012 2.187-.098a3.649 3.649 0 0 0 2.483-2.404c.339-1.069.284-2.074-.163-2.995l-.177-.366.135-.267c.487-.96.555-2.049.196-3.123-.385-1.15-1.405-2.107-2.527-2.371-.275-.065-.724-.082-2.165-.082l-1.818-.001-.325.162'
};
icons.bulletList = {
  width: 29,
  height: 30,
  path: 'M3.11.672C2.066.971 1.235 1.827.993 2.854.899 3.255.898 3.96.992 4.328c.134.528.392.977.792 1.376.644.643 1.248.893 2.155.893.415 0 .606-.024.87-.107.928-.293 1.726-1.085 2.01-1.995a3.163 3.163 0 0 0-.187-2.272C6.373 1.692 5.814 1.142 5.266.88a3.784 3.784 0 0 0-.665-.247C4.214.553 3.456.573 3.11.672m7.33.899A2.117 2.117 0 0 0 8.963 2.99c-.054.186-.073.403-.062.706.014.371.04.486.172.764.321.678.95 1.117 1.722 1.202.225.025 3.87.037 8.443.029 8.94-.016 8.209.012 8.757-.34.838-.539 1.178-1.48.874-2.427-.216-.674-.862-1.246-1.555-1.377-.17-.032-3.09-.047-8.434-.045-6.662.004-8.223.016-8.44.069m-6.052.921c.552.23.854.895.665 1.465-.287.863-1.408 1.093-2.007.411a1.03 1.03 0 0 1-.291-.767c0-.476.228-.855.636-1.059.298-.148.713-.169.997-.05m-.86 9.352c-1.091.125-2.137.982-2.471 2.024-.142.443-.177 1.273-.072 1.696a3.133 3.133 0 0 0 2.103 2.193c.824.242 1.833.084 2.529-.397.539-.371 1.021-1.02 1.212-1.628.151-.483.146-1.362-.01-1.812-.173-.5-.379-.818-.798-1.232-.683-.677-1.51-.957-2.493-.844m6.815 1.006a2.182 2.182 0 0 0-1.276 1.118c-.14.295-.149.349-.149.87 0 .526.008.574.155.884.264.557.775.983 1.367 1.14.165.044 2.225.055 8.606.044l8.388-.014.368-.181a2.102 2.102 0 0 0 1.156-1.55c.151-.928-.41-1.906-1.3-2.265l-.277-.112-8.386-.01c-7.911-.009-8.401-.005-8.652.076m-5.861.943c.173.091.415.35.518.553.284.563.011 1.297-.59 1.582-.429.204-1.037.069-1.364-.303-.736-.835 0-2.135 1.098-1.938.113.02.265.068.338.106M3.451 23.1a3.043 3.043 0 0 0-2.041 1.329c-.332.497-.448.856-.479 1.485-.053 1.087.35 1.984 1.161 2.587.596.442 1.137.615 1.902.609.847-.008 1.54-.318 2.138-.957.332-.355.589-.789.714-1.207.13-.435.121-1.295-.018-1.74-.282-.902-1.067-1.699-1.951-1.98-.409-.13-1.045-.186-1.426-.126m6.914.993a2.2 2.2 0 0 0-1.296 1.132c-.142.3-.151.352-.151.875 0 .502.012.583.129.833.264.563.727.977 1.286 1.15.305.093.471.095 8.583.095 8.813-.001 8.489.007 8.948-.23.773-.399 1.241-1.341 1.087-2.188a2.141 2.141 0 0 0-1.193-1.558l-.329-.156-8.434-.008c-6.759-.006-8.473.005-8.63.055m-5.916.946c.416.209.647.589.647 1.061 0 .675-.498 1.171-1.175 1.169-.443-.001-.765-.178-1.011-.557-.116-.179-.131-.247-.131-.612s.015-.433.131-.612c.343-.528 1.002-.719 1.539-.449'
};
icons.link = {
  width: 33,
  height: 32,
  path: 'M21.615.197c-1.493.169-2.284.364-3.382.833-1.341.572-2.148 1.188-4.082 3.117-1.852 1.849-1.858 1.858-1.858 2.783 0 .506.017.615.141.88.19.405.601.805 1.041 1.013.317.15.414.169.853.169.444 0 .533-.018.875-.18.34-.161.539-.338 1.87-1.656 1.594-1.581 1.908-1.843 2.627-2.194 1.666-.814 3.546-.81 5.188.013 2.668 1.336 3.914 4.387 2.931 7.176-.386 1.094-.622 1.409-2.421 3.232-1.358 1.376-1.551 1.594-1.708 1.925-.158.335-.177.426-.177.869s.019.535.175.865c.507 1.073 1.716 1.506 2.806 1.007.27-.123.555-.383 1.865-1.696 1.593-1.596 2.097-2.194 2.627-3.113a10.443 10.443 0 0 0 1.251-3.662c.091-.63.09-2.107-.002-2.75A10.497 10.497 0 0 0 30.482 4.4c-.483-.684-1.704-1.905-2.377-2.378-1.24-.872-2.791-1.499-4.262-1.723-.51-.078-1.887-.141-2.228-.102m-1.096 9.38a2.536 2.536 0 0 0-.55.17c-.189.09-1.361 1.226-4.719 4.575-4.832 4.82-4.752 4.731-4.846 5.416-.195 1.425.985 2.6 2.382 2.372.674-.109.569-.015 5.376-4.831 4.784-4.794 4.668-4.664 4.774-5.326.228-1.415-.99-2.612-2.417-2.376M7.445 11.444c-.636.084-.806.213-2.415 1.827-1.87 1.877-2.324 2.439-2.913 3.614-.749 1.491-1.079 2.871-1.088 4.537-.008 1.642.311 3.04 1.03 4.511.528 1.078 1.16 1.931 2.091 2.819a10.036 10.036 0 0 0 5.502 2.66c.626.091 2.228.09 2.805-.002 1.954-.311 3.622-1.06 5.061-2.272.272-.229 1.107-1.035 1.855-1.79 1.475-1.488 1.598-1.655 1.69-2.31.232-1.641-1.444-2.867-2.953-2.16-.308.144-.555.364-1.903 1.696-1.021 1.009-1.684 1.619-1.945 1.79-2.296 1.507-5.338 1.217-7.289-.694-2.054-2.012-2.374-5.064-.786-7.493.119-.183.896-1.019 1.744-1.877 1.347-1.364 1.549-1.591 1.699-1.911.712-1.522-.507-3.165-2.185-2.945'
};
icons.blockquote = {
  width: 36,
  height: 32,
  path: 'M32.156.742a27.663 27.663 0 0 0-2.186 1.59c-2.677 2.108-5.227 4.842-7.037 7.547-1.781 2.659-2.917 5.705-3.347 8.965-.129.981-.18 3.353-.089 4.133.26 2.234 1.31 4.508 2.795 6.056a7.728 7.728 0 0 0 4.344 2.312c.725.122 2.215.125 2.894.007 1.64-.286 3.176-1.193 4.101-2.422a7.938 7.938 0 0 0 1.417-3.146c.17-.801.184-2.433.028-3.243-.463-2.413-2.168-4.29-4.483-4.936-.822-.229-2.218-.264-3.606-.091a62.82 62.82 0 0 1-1.042.126c-.06 0 .026-1.486.131-2.274a12.258 12.258 0 0 1 1.939-5.096c.888-1.316 2.054-2.702 3.375-4.011 1.06-1.05 1.737-1.641 2.857-2.493.439-.334.786-.637.773-.673-.024-.062-1.936-2.778-2.014-2.861-.02-.021-.402.208-.85.51M13.26.827A33.164 33.164 0 0 0 4.726 9.09C2.244 12.549.941 16.466.802 20.88c-.071 2.241.233 3.827 1.066 5.579 1.307 2.745 3.38 4.43 6.015 4.888.796.139 2.291.125 3.042-.028 2.995-.61 5.076-2.845 5.554-5.965.138-.9.082-2.33-.121-3.114-.592-2.276-2.351-4.043-4.647-4.664-.868-.235-2.605-.216-4.296.046l-.234.036.038-.954c.114-2.898.989-5.165 2.975-7.708 1.545-1.978 3.312-3.712 5.406-5.303.379-.289.69-.542.69-.564 0-.09-2.026-2.889-2.09-2.887-.038 0-.462.264-.94.585'
};
function createMenuIcon(src) {
  const elm = document.createElement('img');
  elm.className = 'ProseMirror__menu-icon';
  elm.src = src;
  return elm;
}
function createMenuLabel(label) {
  const elm = document.createElement('span');
  elm.className = 'ProseMirror__menu-label';
  elm.textContent = label;
  return elm;
}

/*
  A class that drives the rendering of the menubar at the top of the editor
*/
export class Menu {
  constructor(args) {
    _defineProperty(this, "schema", void 0);
    _defineProperty(this, "excludeMenuItems", void 0);
    _defineProperty(this, "prompt", void 0);
    _defineProperty(this, "variables", void 0);
    _defineProperty(this, "extensions", void 0);
    _defineProperty(this, "menuItems", void 0);
    _defineProperty(this, "isInline", false);
    _defineProperty(this, "isNda", false);
    Object.assign(this, args);
    const format = getDocFormat(this.schema);
    this.isInline = isInlineDocFormat(format);
    this.isNda = format === DocFormatEnum.Nda;
    this.menuItems = buildMenuItems(this.schema);
  }
  get toggleStrong() {
    return this.menuItems[MenuItemEnum.ToggleStrong];
  }
  get insertImage() {
    if (this.isInline) return undefined;
    return new MenuItem({
      ...this.menuItems.insertImage.spec,
      icon: imageIcon,
      run: (state, _dispatch, view) => {
        const {
          from,
          to
        } = state.selection;
        let attrs = {
          alt: state.doc.textBetween(from, to, ' '),
          src: '',
          title: ''
        };
        if (state.selection instanceof NodeSelection && state.selection.node.type == this.schema.nodes.image) {
          attrs = state.selection.node.attrs;
        }
        const callback = () => {
          view.dispatch(view.state.tr.replaceSelectionWith(this.schema.nodes.image.createAndFill(this.prompt.attrs)));
          view.focus();
        };
        this.prompt.render('image', callback, attrs);
      }
    });
  }
  get toggleLink() {
    if (this.isInline) return undefined;
    const {
      toggleLink
    } = this.menuItems;
    return new MenuItem({
      ...toggleLink.spec,
      run: (state, dispatch, view) => {
        if (markActive(state, this.schema.marks.link)) {
          toggleMark(this.schema.marks.link)(state, dispatch);
          return true;
        }
        const callback = () => {
          toggleMark(this.schema.marks.link, this.prompt.attrs)(view.state, view.dispatch);
          view.focus();
        };
        this.prompt.render('link', callback, {
          href: 'https://',
          title: ''
        });
      }
    });
  }
  get textTypeMenu() {
    if (this.isInline) return undefined;
    return new WithActiveAsLabelDropdown([new MenuItem({
      ...this.menuItems.makeParagraph.spec,
      label: 'Normal'
    }), new MenuItem({
      ...this.menuItems.makeHead1.spec,
      label: 'Heading 1',
      class: 'h1'
    }), new MenuItem({
      ...this.menuItems.makeHead2.spec,
      label: 'Heading 2',
      class: 'h2'
    }), new MenuItem({
      ...this.menuItems.makeHead3.spec,
      label: 'Heading 3',
      class: 'h3'
    }), new MenuItem({
      ...this.menuItems.makeHead4.spec,
      label: 'Heading 4',
      class: 'h4'
    }), new MenuItem({
      ...this.menuItems.makeHead5.spec,
      label: 'Heading 5',
      class: 'h5'
    }), new MenuItem({
      ...this.menuItems.makeHead6.spec,
      label: 'Heading 6',
      class: 'h6'
    })], {
      label: 'Type...'
    });
  }
  get variablesMenu() {
    return new Dropdown(this.variables.map(variable => {
      return new MenuItem({
        title: `Insert ${variable}`,
        label: prettyPrintLabel(variable),
        class: 'ProseMirror__variables-menu-item',
        enable: state => insertVariable(variable)(state),
        run: insertVariable(variable)
      });
    }), {
      label: 'Variables',
      class: 'ProseMirror__variables-menu'
    });
  }
  get extensionsMenu() {
    return new Dropdown(this.extensions.map(({
      label,
      token,
      icon
    }) => {
      return new MenuItem({
        title: `Insert ${label}`,
        class: 'ProseMirror__extensions-menu-item',
        enable: state => insertPillbox(label, token)(state),
        run: insertPillbox(label, token),
        render() {
          const elm = document.createElement('div');
          if (isPresent(icon)) {
            elm.append(createMenuIcon(icon));
          }
          elm.append(createMenuLabel(label));
          return elm;
        }
      });
    }), {
      label: 'Add dynamic content',
      class: 'ProseMirror__extensions-menu'
    });
  }
  get menu() {
    this.menuItems[MenuItemEnum.InsertImage] = this.insertImage;
    this.menuItems[MenuItemEnum.ToggleLink] = this.toggleLink;
    this.menuItems[MenuItemEnum.TextTypeMenu] = this.textTypeMenu;
    this.menuItems[MenuItemEnum.VariablesMenu] = this.variablesMenu;
    this.menuItems[MenuItemEnum.ToggleStrong] = this.toggleStrong;
    if (isPresent(this.extensions)) {
      this.menuItems[MenuItemEnum.ExtensionsMenu] = this.extensionsMenu;
    }
    return menuBarBuilder(this.menuItems, this.excludeMenuItems, this.variables);
  }
}